import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseA2 = props => <ServerComponentCaller url={"assets/data/pages/licencias/A2.json"}/>;

export default LicenciaClaseA2;
